import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { handleNavbarColor } from '../../store/layout';

export const useNavbarColor = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const store = useSelector((state) => state.layout);

  // ** Return a wrapped version of useState's setter function
  const setNavbarColor = useCallback((value) => {
    dispatch(handleNavbarColor(value));
  }, [dispatch]);

  return { navbarColor: store.navbarColor, setNavbarColor };
};
